import { useCallback } from "react";
import type { Event } from "../types";

interface DeletionStatus {
  canDelete: boolean;
  reason?: string;
}

export function useParticipantDeletion(event: Event | null) {
  const canDeleteParticipant = useCallback(
    (participantId: string): DeletionStatus => {
      if (!event) {
        return { canDelete: false, reason: "No hay evento activo" };
      }

      const isPayer = event.expenses.some(
        (expense) => expense.paidById === participantId
      );
      if (isPayer) {
        return {
          canDelete: false,
          reason: "Este participante ha pagado gastos",
        };
      }

      const isInExpense = event.expenses.some((expense) =>
        expense.participantIds.includes(participantId)
      );
      if (isInExpense) {
        return {
          canDelete: false,
          reason: "Este participante tiene gastos asociados",
        };
      }

      return { canDelete: true };
    },
    [event]
  );

  return { canDeleteParticipant };
}
